import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { CreateFeedback, FeedbackResponse } from '../interfaces/feedback';

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  getFeedbackData(locator: string, reservationItemId: number): Observable<FeedbackResponse> {
    return this.http.get<FeedbackResponse>(`${environment.apiUrl}feedback/${locator}/${reservationItemId}`);
  }

  submitFeedback(feedback: CreateFeedback): Observable<any> {
    return this.http.post(`${environment.apiUrl}feedback`, feedback);
  }
}
